export const vehicleType = [
  {
    value: 2,
    label: "2 Wheeler",
  },
  {
    value: 3,
    label: "3 Wheeler",
  },
  {
    value: 4,
    label: "4 Wheeler",
  },
]

export const connectorLevel = [
  {
    value: 1,
    label: "Level 1",
  },
  {
    value: 2,
    label: "Level 2",
  },
  {
    value: 3,
    label: "Level 3",
  },
]

export const currentType = [
  {
    value: "AC",
    label: "AC",
  },
  {
    value: "DC",
    label: "DC",
  },
]

export const modulePermission = {
  dashboard: "dashboard",
  booking: "booking management",
  user: "user management",
  station: "station management",
  review: "review management",
  charger: "charger management",
  setting: "settings",
  fleetManagement: "fleet management",
}
